import React, { useEffect } from "react";
import hero_1 from "../assets/hero_1.webp";
import hero_banner_home from "../assets/hero_banner_home.webp";
import { Link } from "react-router-dom";

const Herosection = () => {
  return (
    <>
      
      <div className="hero-blur-top-right"></div>
      <div className="hero-containers">
        <div className="herosection">
          <div className="hero-text">
            <h1
              className="mt-5 mb-2 mb-lg-4 fs-md-2 fs-lg-1 fw-semibold"
              style={{ color: " #4B4B4B" }}
            >
              Move into your <br className="" />
              Dream Home
            </h1>
            <p className=" fs-5 fs-md-5 p-text ">
              With a Hassle-
              <br className="  d-md-none" />
              Free Home Loan
            </p>
            <Link
              to="/homeloan"
              className="btn bg-primary text-white fw-semibold hero-button d-flex align-items-center rounded-4 px-md-3 py-1 py-md-2 mb-2 "
              style={{ width: "fit-content", fontFamily: "poppins" }}
            >
              Apply Now
              <i className="fas fa-arrow-right ms-2 ms-md-3"></i>
            </Link>
          </div>

          <div className="bg-shape1-desktop"></div>
          <div className="bg-shape1-tablet"></div>
          <div className="bg-shape1-mobile"></div>

          <img src={hero_1} alt="Person" className="hero-img-desktop" />
          <img src={hero_1} alt="Person" className="hero-img-tablet" />
          <img src={hero_1} alt="Person" className="hero-img-mobile" />
          <img src={hero_banner_home} alt="Secondary" className="hero-img-secondary" />

          <div className="tc-button">
            <Link to="/term">
              <button style={{ color: "#4B4B4B", fontFamily: "poppins" }}>T&C apply</button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Herosection;